<template>
  <form-field-select
    :label="label"
    v-model="filterValue"
    placeholder="no filter"
    @change="handleInput"
    :help-text="helpText"
  >
    <option :value="0">All Manual Follow Ups</option>
    <option :value="1">Past Due Manual Follow Ups</option>
  </form-field-select>
</template>

<script>
export default {
  name: "FilterSequenceNextContact",
  props: {
    label: {
      type: String,
      default: "Past Due Follow Ups"
    },
    storeModule: {
      type: String,
      required: true
    },
    filterName: {
      type: String,
      required: true
    },
    helpText: String,
  },
  computed: {
    filterValue: {
      get() {
        return this.$store.state[this.storeModule].filters[this.filterName].pastNextContact;
      },
      set(value) {
        this.$store.commit(this.storeModule + "/setOneFilter", [
          this.filterName,
          "pastNextContact",
          value
        ]);
      }
    },
    text() {
      if (this.filterValue && this.filterValue === 1) return "Past Due Manual Follow Ups Only";
      return null;
    },
  },
  created() {
    this.handleInput();
  },
  methods: {
    handleInput() {
      this.$emit("change", this.text);
    },
  }
};
</script>
